import { Flex } from 'antd';
import EditButton from './EditButton';
import ActiveDeactivateButton from './ActiveDeactiveButton';

const ActiveEditButton = ({ editNavigation, activationStatus, deactivateHandler }) => {
	return (
		<Flex style={{ gap: '4px' }} justify="flex-end" align="flex-end">
			{activationStatus && (
				<ActiveDeactivateButton
					activationStatus={activationStatus}
					handleOnClick={(e) => {
						e.stopPropagation();

						deactivateHandler();
					}}
				/>
			)}

			<EditButton
				handleOnClick={(e) => {
					e.stopPropagation();

					editNavigation();
				}}
			/>
		</Flex>
	);
};

export default ActiveEditButton;
